import { loadScriptInHead } from '../../utils/dom';

const SAILTHRU_CUSTOMER_ID = '1e75b3399eb25ed085683b40f2055181';

export default function SailthruHorizon() {
  loadScriptInHead('marketing', `https://ak.sail-horizon.com/spm/spm.v1.min.js`, () => {
    window.Sailthru && window.Sailthru.init({ customerId: SAILTHRU_CUSTOMER_ID });
  });
}
